<template>
  <span class="base-page-loader"/>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.base-page-loader,
.base-page-loader:before,
.base-page-loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.8s infinite ease-in-out;
}
.base-page-loader {
  color: var(--black-monochrome-60);
  font-size: 7px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;
}
.base-page-loader:before,
.base-page-loader:after {
  content: "";
  position: absolute;
  top: 0;
}
.base-page-loader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}
.base-page-loader:after {
  left: 3.5em;
}

@keyframes bblFadInOut {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
</style>
